import { render, staticRenderFns } from "./UN_dash2.vue?vue&type=template&id=683bccad&"
import script from "./UN_dash2.vue?vue&type=script&lang=js&"
export * from "./UN_dash2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports